import styled from 'styled-components';

export const Wrap = styled.div`
  position: relative;

  .dropdown {
    max-width: fit-content;
  }

  .dropdown.ant-dropdown-placement-bottomRight,
  .dropdown.ant-dropdown-placement-topRight {
    width: max-content;
    max-width: none;
  }
`;
